import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from 'vuex-module-decorators';
import store from '@/store';
import { TransitionType } from '@/config/enum';

@Module({ namespaced: true, name: 'transition', store, dynamic: true })
export class TransitionModule extends VuexModule {
  public transitionType: TransitionType = TransitionType.fade;

  @MutationAction
  async updateMenuStatus(transitionType: TransitionType) {
    return { transitionType };
  }
}

const transitionModule = getModule(TransitionModule);
export default transitionModule;
